import { FullscreenExitOutlined, FullscreenOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import { observer } from 'mobx-react-lite';

type FullscreenExpandButtonProps = {
  isExpanded: boolean;
  onClick: () => void;
};

export const FullscreenExpandButton = observer(
  ({ isExpanded, onClick }: FullscreenExpandButtonProps) => {
    return (
      <Button
        type={isExpanded ? 'primary' : 'default'}
        onClick={() => onClick()}
        icon={
          isExpanded ? (
            <FullscreenExitOutlined style={{ color: '#fff' }} />
          ) : (
            <FullscreenOutlined style={{ color: '#2664CD' }} />
          )
        }
      >
        {isExpanded ? 'Свернуть' : 'Развернуть'}
      </Button>
    );
  },
);
